<template>
  <div class="company-list" v-if="isDisplayCompanyList">
    <el-row>
      <el-col :span="4" style="padding-right: 10px">
        <el-select v-model="selectedCompanyCode" @change="changeCompany" placeholder="Select company" size="small" style="width: 100%">
          <el-option
            v-for="(company, index) in companyList"
            :key="index"
            :label="company.name"
            :value="company.code">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { USER_TYPE_HG_ADMIN_GROUP, STATUS } from '@/configs/constant'
import CompanyApi from '@/api/company-api'
import { getHotelIndexRoute } from '@/services/hotel-service'
import { dynamicSort, filterDisableList } from '@/helpers'

export default {
  name: 'CompanyListTemplate',
  mixins: [LoadingViewMixin, AlertViewMixin],
  components: {},
  created: function () {
    const userDetail = LocalStorageFactory.getUserDetail()
    if (userDetail === undefined) {
      return
    }

    const isHGAdmin = _isHGAdmin(userDetail.userTypeId)
    if (isHGAdmin) {
      const companyList = LocalStorageFactory.getCompanyList()
      this.companyList = companyList.sort(dynamicSort('name'))
      this.companyList = filterDisableList(this.companyList)
      this.companyDetail = LocalStorageFactory.getCompanyDetail()

      if (this.companyDetail !== null) {
        this.selectedCompanyCode = this.companyDetail.code
      }

      this.isDisplayCompanyList = true
    }
  },
  data () {
    return {
      companyList: [],
      companyDetail: {
        code: '',
        name: '',
        companyType: 0,
        isEnable: STATUS.DISABLE
      },
      selectedCompanyCode: '',
      isDisplayCompanyList: false
    }
  },
  methods: {
    changeCompany: async function () {
      this.startLoading()

      try {
        const result = await CompanyApi.changeCompany(this.selectedCompanyCode)
        const newAgentList = []
        const newAgentListCacheVersion = 0

        LocalStorageFactory.setToken(result.token)
        LocalStorageFactory.setCompanyDetail(result.companyData)
        LocalStorageFactory.setAgentList(newAgentList)
        LocalStorageFactory.setAgentListCacheVersion(newAgentListCacheVersion)

        this.companyDetail = result.companyData
        const routeName = await getHotelIndexRoute(this.companyDetail, this.$store)

        this.$router.push({
          name: routeName
        })
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    }
  }
}

function _isHGAdmin (userTypeId) {
  const isHGAdmin = USER_TYPE_HG_ADMIN_GROUP.includes(userTypeId)

  return isHGAdmin
}
</script>

<style>
  .company-list {
    padding: 10px 10px;
    background-color: #EBEBEB;
  }
</style>
